export default __webpack_public_path__ + "static/Lato-Regular-9919edff6283018571add043109dc20b.ttf";